<template>
    <div class="question relative flex-1" :class="{'question--answered': isAnswered}">
        <Image :src="questionImageUrl" class="question-image content content--full-mobile select-none" />
        <QuestionNumber :number="number" class="question-number content content--full-mobile" />
        <h1 class="content">{{ question.label }}</h1>
        <TransitionGroup name="answers" tag="div" class="answers content flex flex-col gap-10 relative">
            <Answer v-for="(answer, index) in answers"
                    :key="answer.id"
                    :answer="answer"
                    :index="index"
                    :is-answered="isAnswered"
                    :incorrect-info="question.incorrect_info"
                    :selected-answer="answerId === answer.id"
                    :question-image="question.image"
                    @answered="questionAnswered"
            />
        </TransitionGroup>
        <div v-if="isAnswered" class="text-center">
            <ButtonElement @click="advanceClicked">următoarea întrebare</ButtonElement>
        </div>
    </div>
</template>

<script>
import User from "../Modules/User";
import Image from "./Image.vue";
import QuestionNumber from "./QuestionNumber.vue";
import Answer from "./Answer.vue";
import ButtonElement from "../Common/Button.vue";

export default {
	name: "QuestionElement",
	components: {ButtonElement, Answer, QuestionNumber, Image},
	props: {
		question: Object,
		user: User,
		number: Number,
	},
	data: () => ({
		randomHack: 0,
		answerId: null,
		answerIds: [],
		isAnswered: false,
		isCorrect: false,
	}),
	emits: ["advance"],
	computed: {
        questionImageUrl() {
            return `/img/illustrations/${this.question.image}.png`;
        },
		answers() {
			console.log(this.randomHack);
			const shuffleArray = array => {
				for (let i = array.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[array[i], array[j]] = [array[j], array[i]];
				}
				return array;
			};
			return shuffleArray(this.question.answers);
		},
		hasComponent() {
			return ["card", "image", "lottie"].includes(this.question.component);
		},
		componentName() {
			if (!this.hasComponent) { return ""; }
			else return this.question.component ==="image" ? "image_holder" : this.question.component;
		},
	},
	methods: {
		reset() {
			this.answerId = null;
			this.answerIds = [];
			this.isCorrect = false;
			this.isAnswered = false;
		},
		questionAnswered(answer) {
			this.isAnswered = true;
			this.answerId = answer.id;
			this.isCorrect = answer.is_correct;
			window.emitter.emit("markAnswer", this.question, answer);
		},
		advanceClicked() {
			this.reset();
			this.$emit("advance");
			window.emitter.emit("questionAdvanced");
			this.randomHack ++;
		},
	},
	mounted() {
		if (this.question.answerId) {
			this.answerId = this.question.answerId;
			this.isCorrect = this.question.answers.find(a => a.id === this.answerId).is_correct;
		}
	},
	created() {
		window.emitter.on("forceReset", () => {
			this.reset();
			this.randomHack ++;
		});
	}
};
</script>

<style scoped lang="scss">
.question {
    --title-size: 24px;
    --title-leading: 30px;
    --vertical-spacing: 40px;

    @media (min-width: 1024px) {
        --title-size: 30px;
        --title-leading: 42px;
        --vertical-spacing: 60px;
    }

    h1 {
        font-size: var(--title-size);
        line-height: var(--title-leading);
        font-weight: 500;
        text-align: center;
    }

    h1,
    .question-number {
        margin-top: var(--vertical-spacing);
        margin-bottom: var(--vertical-spacing);
    }

    button {
        margin-top: var(--vertical-spacing);
    }

    .answers-move,
    .answers-enter-active,
    .answers-leave-active {
        transition: all .4s var(--transition-bounce);
    }

    .answers-enter-from {
        opacity: 0;
        transform: scale(1.2);
    }

    .answers-leave-to {
        opacity: 0;
        transform: scale(0.5);
        transition: none;
    }

    .answers-leave-active {
        position: absolute;
    }
}
</style>
